export const computationFormula = [
  { value: "FIXED_FORMULA", label: "Fixed Formula" },
  { value: "TARGET_FORMULA", label: "Target Formula" },
];

export const directAnswer = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const savingsFrequency = [
  { value: "daily", label: "daily" },
  { value: "weekly", label: "weekly" },
  { value: "monthly", label: "monthly" },
];

export const interestOptions = [
  { value: "UPFRONT_INTEREST_RATE", label: "Upfront Interest Rate" },
  { value: "MONTHLY_INTEREST_RATE", label: "Monthly Interest Rate" },
  { value: "QUATERLY_INTEREST_RATE", label: "Quarterly Interest Rate" },
  { value: "BIANNUAL_INTEREST_RATE", label: "BiAnnual Interest Rate" },
  { value: "BACKEND_UPFRONT_INTEREST_RATE", label: "Backend Upfront Interest Rate" },
  { value: "BACKEND_MONTHLY_RATE", label: "Backend Monthly Rate" },
  { value: "BACKEND_QUATERLY_RATE", label: "Backend Quarterly Rate" },
  { value: "BACKEND_BIANNUAL_RATE", label: "Backend BiAnnual Rate" },
  { value: "BACKEND_MATURITY_RATE", label: "Backend Maturity Rate" },
];

export const interestFormula = [
  { label: "Simple Interest", value: "SIMPLE_INTEREST_FORMULAR" },
  { label: "Compound Interest", value: "COMPOUND_INTEREST_FORMULAR" },
];

export const processOptions = [
  { value: "NEW_INVESTMENT_BACKEND", label: "New Investment Backend" },
  { value: "TOPUP_BACKEND", label: "Top Up Backend" },
  { value: "TRANSFER_BACKEND", label: "Transfer Backend" },
  { value: "ROLLOVER_BACKEND", label: "Rollover Backend" },
  { value: "FULL_WITHDRAWAL_TO_BANK_FRONTEND", label: "Full Withdrawal to Bank Frontend" },
  { value: "PART_WITHDRAWAL_TO_BANK_FRONTEND", label: "Part Withdrawal to Bank Frontend" },
  { value: "PART_WITHDRAWAL_TO_BANK_BACKEND", label: "Part Withdrawal to Bank Backend" },
  { value: "FULL_WITHDRAWAL_TO_BANK_BACKEND", label: "Full Withdrawal to Bank Backend" },
  { value: "PART_WITHDRAWAL_FROM_WALLET_TO_BANK_FRONTEND", label: "Part Withdrawal From Wallet to Bank Frontend" },
  { value: "FULL_WITHDRAWAL_FROM_WALLET_TO_BANK_FRONTEND", label: "Full Withdrawal From Wallet to Bank Frontend" },
];

export const manageUserStatus = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
  { value: "locked", label: "locked" },
];

export const months = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const days = [
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednessday" },
  { value: "4", label: "Thursday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" },
  { value: "7", label: "Sunday" },
];

export const years = [
  { value: "1", label: "2018" },
  { value: "2", label: "2019" },
  { value: "3", label: "2020" },
  { value: "4", label: "2021" },
  { value: "5", label: "2022" },
  { value: "6", label: "2023" },
  { value: "7", label: "2024" },
];

export const roles = [
  { value: "ADMINISTRATOR", label: "Administrator" },
  { value: "SUPER_ADMINISTRATOR", label: "Super Administrator" },
];

export const sources = [
  { value: "ROSABON_SALES", label: "Rosabon Sales" },
  { value: "ANOTHER_USER", label: "Another User" },
  { value: "OTHER", label: "Other" },
];

export const statusOptions = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
];
